var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-badge',{staticClass:"badge-width",attrs:{"pill":"","variant":_vm.statusVariant}},[_vm._v(" "+_vm._s(_vm.statusCheck(this.status))+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }